import MantaVideoComponentsContainer from './containers/MantaVideoComponentsContainer';
export default MantaVideoComponentsContainer;
